/* Lazy-load videos: detach <source>s so nothing downloads until the clip is
   scrolled near the viewport, then restore + play. Off-screen clips pause.
   Setting preload="none" alone is too late (the metadata/loop fetch starts at
   parse time), so we strip the src and call load() to abort any in-flight fetch.
   Reversible: delete this file + its <script> tag in theme.liquid. */
(function () {
  function detach(v) {
    // stash <source> urls, then clear them so the browser has nothing to fetch
    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) {
      var s = srcs[i];
      if (s.getAttribute('src')) { s.setAttribute('data-src', s.getAttribute('src')); s.removeAttribute('src'); }
    }
    if (v.getAttribute('src')) { v.setAttribute('data-vsrc', v.getAttribute('src')); v.removeAttribute('src'); }
    v.removeAttribute('autoplay');
    v.preload = 'none';
    try { v.load(); } catch (e) {} // abort any fetch already started at parse time
  }

  function attach(v) {
    if (v.getAttribute('data-loaded') === '1') return;
    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) {
      var s = srcs[i];
      if (s.getAttribute('data-src')) { s.setAttribute('src', s.getAttribute('data-src')); }
    }
    if (v.getAttribute('data-vsrc')) { v.setAttribute('src', v.getAttribute('data-vsrc')); }
    v.setAttribute('data-loaded', '1');
    v.preload = 'auto';
    try { v.load(); } catch (e) {}
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var vids = scope.querySelectorAll('video[autoplay], video[data-lazy-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          attach(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px' });

    vids.forEach(function (v) {
      if (v.getAttribute('data-lazy-video') === 'done') return;
      v.setAttribute('data-lazy-video', 'done');
      detach(v);
      io.observe(v);
    });
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
